import AddSampleAndProps from './AddSampleAndProps'
import SearchAndAddToShipment from './SearchAndAddToShipment'
import UnavailableShipmentSamplesAndProps from './UnavailableShipmentSamplesAndProps'

AddSampleAndProps.SearchAndAdd = SearchAndAddToShipment
AddSampleAndProps.UnavailableShipmentSamplesAndProps =
  UnavailableShipmentSamplesAndProps

export default AddSampleAndProps
